import React from 'react';
import PropTypes from 'prop-types';
import { IcepackStateForm } from '../icepack-state-form';
import { SimpleTableComponent } from '../../../../components/simple-table';
import { ICEPACK_STATE_TABLE_COLUMNS_NAMES } from '../../constants';

export const IcepackStateModalContent = ({ isLoading, icepackStateInfo, isIcepackStateFormOpen }) => {
	if (isIcepackStateFormOpen) {
		return <IcepackStateForm isLoading={isLoading} />;
	}

	return (
		<SimpleTableComponent
			rows={icepackStateInfo}
			isTableDataLoading={isLoading}
			columns={ICEPACK_STATE_TABLE_COLUMNS_NAMES}
			withOutMinHeight
		/>
	);
};

IcepackStateModalContent.propTypes = {
	isLoading: PropTypes.bool.isRequired,
	icepackStateInfo: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			title: PropTypes.string.isRequired,
			value: PropTypes.oneOfType([
				PropTypes.string,
				PropTypes.shape({
					name: PropTypes.string,
					role: PropTypes.string,
				}),
			]).isRequired,
		}),
	),
	isIcepackStateFormOpen: PropTypes.bool.isRequired,
};
